import React from "react";
import { Paper, TableContainer, Table, TableBody, TableHead, TableRow, TableCell } from "@material-ui/core";
import LastNewsTableRow from "./LastNewsTableRow";
import PropTypes from "prop-types";

const LastNewsTable = ({ handleEditItem, handleDeleteItem, news, pagination }) =>
  news.length === 0 ? (
    <Paper className="p-4 text-center">لا توجد أخبار</Paper>
  ) : (
    <TableContainer component={Paper} className="table-responsive">
      <Table className="table table-fixed">
        <TableHead>
          <TableRow className="last-news__theader">
            <TableCell align="center">#</TableCell>
            <TableCell align="center">عنوان الخبر</TableCell>
            <TableCell align="center">النص</TableCell>
            <TableCell align="center">افعال</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {news.map((item, index) => (
            <LastNewsTableRow
              {...item}
              index={index + 1}
              handleEditItem={() => handleEditItem(item.id)}
              handleDeleteItem={() => handleDeleteItem(item.id)}
              key={item.id}
              pagination={pagination}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

LastNewsTable.propTypes = {
  handleEditItem: PropTypes.func.isRequired,
  handleDeleteItem: PropTypes.func.isRequired,
  news: PropTypes.array.isRequired,
};

export default LastNewsTable;
